// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-pagination{align-items:center;color:var(--color-gray-500);display:flex;font-size:var(--font-size-lg);gap:var(--spacing-2xs);justify-content:center;margin-top:var(--spacing-md)}@media screen and (min-width:769px){.gw-pagination{font-size:var(--font-size-lg);margin-top:var(--spacing-4xl)}}.gw-pagination a{cursor:pointer;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
